import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Loader2, X } from "lucide-react";
import { api } from "@/api/client";
import AlbumTree from "@/components/media/AlbumTree";

/** Add the selected media to an album (membership-add, never removes). */
export default function AddToAlbumModal({
  mediaIds,
  onClose,
  onDone,
}: {
  mediaIds: string[];
  onClose: () => void;
  onDone: () => void;
}) {
  const [target, setTarget] = useState<string | null>(null);
  const addMutation = useMutation({
    mutationFn: (folderId: string) =>
      api.post(`/api/admin/media-folders/${folderId}/items`, { mediaIds }),
    onSuccess: onDone,
  });

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="flex max-h-[80vh] w-full max-w-sm flex-col overflow-hidden rounded-xl bg-white shadow-xl dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-gray-200 p-4 dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Add {mediaIds.length} image(s) to album
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <AlbumTree manage selectedId={target} onSelect={setTarget} />
        </div>
        <div className="flex justify-end gap-2 border-t border-gray-200 p-4 dark:border-gray-700">
          <button onClick={onClose} className="btn-ghost text-sm">
            Cancel
          </button>
          <button
            onClick={() => target && addMutation.mutate(target)}
            disabled={!target || addMutation.isPending}
            className="btn-primary text-sm"
          >
            {addMutation.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Add to album"}
          </button>
        </div>
      </div>
    </div>
  );
}
